import { BufferGeometry, Line, Vector3 } from 'three';
import { H3BasicMaterial } from '../../../materials/basic/h3-basic-material';
import { PointCloudContentState } from '../../../state/point-cloud-content-state';
import { RendererLayer, setRendererLayers } from '../../render-utils';
import {
  AbstractMeshHelper,
  ConfigureMeshesConfiguration,
} from '../abstract-mesh-helper';

export const lineColor = '#E3E44C';

export class MeasurementLineHelper extends AbstractMeshHelper {
  private line: Line<BufferGeometry, H3BasicMaterial>;

  constructor() {
    super();
    this.line = new Line(new BufferGeometry());
    this.line.userData = { meshType: 'MeasurementLine' };
    // Prevents the line from not being rendered whenever the
    // starting point is outside of camera's view
    this.line.frustumCulled = false;
  }

  update(startPosition: Vector3, endPosition: Vector3) {
    this.line.geometry.setFromPoints([startPosition, endPosition]);
    this.line.computeLineDistances();
  }

  dispose() {
    this.line.geometry.dispose();
    this.line.material.dispose();
  }

  override getMeshes() {
    return [this.line];
  }

  protected override updateRendererLayers(_state: PointCloudContentState) {
    setRendererLayers([RendererLayer.Main], this.line);
  }

  protected override configureMeshes({
    materialService,
  }: ConfigureMeshesConfiguration) {
    this.line.material = materialService.get(H3BasicMaterial, {
      color: lineColor,
    });
  }
}
